import { CustomerState } from '../customer/state'

export const getters = {
    isAdmin: (state: CustomerState): boolean => {
        return state.isAdmin
    },
}
